module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0022.jpg?v=ed88432e";